jQuery(document).ready(function($) {
	$('.factbox').each(function (index, element) {
		const text = $(element).find('.text');
		text.data('max-height', text[0].scrollHeight);
		text.css('max-height', 0);

		$(element).find('button').click(function () {
			$(element).toggleClass('open');

			if ($(element).hasClass('open')) {
				text.css('max-height', text.data('max-height'));
			} else {
				text.css('max-height', 0);
			}
		});
	});
});
